var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWebhook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.615 10.36L6.13 7.54a3.384 3.384 0 115.063-1.692m-.372 5.64a1.128 1.128 0 112.257 0 1.128 1.128 0 01-2.257 0zm0 0H7.436A3.383 3.383 0 011.12 13.18a3.384 3.384 0 012.366-5.03m5.077-2.303l1.692 2.71a3.384 3.384 0 11-.83 5.189M8 3.589a1.128 1.128 0 100 2.257A1.128 1.128 0 008 3.59zM4.05 10.36a1.128 1.128 0 100 2.256 1.128 1.128 0 000-2.256z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

export default SvgWebhook;